import { Tooltip } from "antd";
import React from "react";

import { listViews } from "@/Constants/common";

import ActionIcons from "../../../ActionIcons";

const SwitchListView = ({ value, handleClick }) => {
  return (
    <div className="SwitchListView_Wrapper tour-booked-switch-button tour-worked-switch-button">
      <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9]">
        {listViews.map((item, index) => {
          return (
            <Tooltip title={item.title} key={index}>
              <div
                className={`group ${value === item.value ? "bg-primary text-white" : "text-txtColor"}`}
                onClick={() => {
                  handleClick(item.value);
                }}
              >
                <ActionIcons isLoading={false} type={item.value} />
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

export default SwitchListView;
